import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';

import {
  getBlogSubRoute,
  getBlogSeoTitle,
  getBlogSeoDescription,
} from '_helpers/blog';

import BlogArticlePage from '_components/composed/pages/BlogArticlePage';

export default function BlogArticle() {
  const router = useRouter();
  const route = getBlogSubRoute(router.pathname);
  const title = getBlogSeoTitle(route);
  const description = getBlogSeoDescription(route);

  return (
    <>
      <NextSeo title={title} description={description} />
      <BlogArticlePage />
    </>
  );
}
